class AppSectionsStorage {
  constructor() {
    this.storage = {};
  }
  store(section, name, fn) {
    const slot = this.getSlot(section);
    if (!slot[name]) {
      slot[name] = fn();
    }

    return slot[name];
  }
  clean(section, name = null) {
    if (name) {
      const slot = this.getSlot(section);
      delete slot[name];
    } else {
      delete this.storage[section];
    }
  }
  cleanAll() {
    Object.keys(this.storage).forEach((section) => {
      this.clean(section);
    });
  }
  getSlot(section) {
    if (!this.storage[section]) {
      this.storage[section] = {};
    }

    return this.storage[section];
  }
}

export default AppSectionsStorage;
